import {useQueryClient} from '@tanstack/react-query'

import {materialsRecipesQueryOptions} from './useMaterialsRecipes'

export const usePrefetchMaterialsRecipes = (plantCode: string, assetType?: string) => {
  const queryClient = useQueryClient()
  void queryClient.prefetchQuery(materialsRecipesQueryOptions(plantCode, assetType))
}
